import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getKanban } from 'interfaces/kanban';
import CreateButton from 'components/buttons/CreateButton';

const formatEuro = (value: number) =>
    value.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });

const ProspectListView = (props: { cards: any[]; onCardClick?: (id: string) => void }) => {
    const { cards, onCardClick } = props;
    const [columns, setColumns] = useState<any[]>([]);
    const navigate = useNavigate();

    const initColumns = async () => {
        const kanban = await getKanban();
        if (kanban) setColumns(kanban.columns);
    };

    useEffect(() => {
        initColumns();
    }, []);

    const grandTotalMonthly = cards.reduce(
        (sum, card) => sum + (Number(card.potentialMonthlyRevenue) || 0),
        0,
    );

    return (
        <div className="mt-4">
            <div className="flex justify-end mb-3">
                <CreateButton
                    value="+ Ajouter un prospect"
                    onClick={() => navigate('/create-prospect')}
                />
            </div>
            <div className="overflow-x-auto rounded-xl border border-gray-200">
                <table className="min-w-full text-sm text-gray-700">
                <thead className="bg-gray-50 text-gray-600">
                    <tr>
                        <th className="text-left py-3 px-4">Entreprise</th>
                        <th className="text-left py-3 px-4">Contact</th>
                        <th className="text-left py-3 px-4">Étape de vente</th>
                        <th className="text-right py-3 px-4">Montant mensuel envisageable</th>
                        <th className="text-right py-3 px-4">Montant annuel envisageable</th>
                    </tr>
                </thead>
                <tbody>
                    {columns.map((column) => {
                        const columnCards = cards.filter(
                            (card) => card.columnId === column.id,
                        );
                        if (columnCards.length === 0) return null;

                        const columnTotal = columnCards.reduce(
                            (sum, card) => sum + (Number(card.potentialMonthlyRevenue) || 0),
                            0,
                        );

                        return (
                            <Fragment key={column.id}>
                                <tr className="border-t border-gray-200 bg-gray-50">
                                    <td className="py-2 px-4 font-semibold" colSpan={3}>
                                        {column.title} ({columnCards.length})
                                    </td>
                                    <td className="py-2 px-4 text-right font-semibold">
                                        {formatEuro(columnTotal)} / mois
                                    </td>
                                    <td className="py-2 px-4 text-right font-semibold">
                                        {formatEuro(columnTotal * 12)} / an
                                    </td>
                                </tr>
                                {columnCards.map((card: any) => (
                                    <tr
                                        key={card._id}
                                        className="border-t border-gray-100 hover:bg-gray-50 cursor-pointer"
                                        onClick={() => onCardClick && onCardClick(card._id)}
                                    >
                                        <td className="py-3 px-4 font-medium text-gray-800">
                                            {card.company || card.displayName}
                                        </td>
                                        <td className="py-3 px-4">
                                            {card.contact || card.mail || card.phone || '-'}
                                        </td>
                                        <td className="py-3 px-4">{column.title}</td>
                                        <td className="py-3 px-4 text-right">
                                            {card.potentialMonthlyRevenue
                                                ? formatEuro(Number(card.potentialMonthlyRevenue))
                                                : '-'}
                                        </td>
                                        <td className="py-3 px-4 text-right">
                                            {card.potentialMonthlyRevenue
                                                ? formatEuro(Number(card.potentialMonthlyRevenue) * 12)
                                                : '-'}
                                        </td>
                                    </tr>
                                ))}
                            </Fragment>
                        );
                    })}
                </tbody>
                <tfoot>
                    <tr className="border-t-2 border-gray-300 bg-gray-50">
                        <td className="py-3 px-4 font-bold" colSpan={3}>
                            Total
                        </td>
                        <td className="py-3 px-4 text-right font-bold">
                            {formatEuro(grandTotalMonthly)} / mois
                        </td>
                        <td className="py-3 px-4 text-right font-bold">
                            {formatEuro(grandTotalMonthly * 12)} / an
                        </td>
                    </tr>
                </tfoot>
            </table>
            </div>
        </div>
    );
};

export default ProspectListView;
